import { Dropdown } from '@silverfort/sf-components';
import { FC } from 'react';
import { RISK_LEVELS } from '@silverfort-nodelibs/common/utils/consts';

const RISK_OPTIONS = Object.values(RISK_LEVELS)
    .filter((risk) => risk.value < RISK_LEVELS.CRITICAL.value)
    .map(({ value, label }) => ({
        value: value,
        title: label[0].toUpperCase() + label.slice(1).toLowerCase()
    }));

interface RiskPickerTabProps {
    riskLevel?: number;
    updateRiskLevel: (level?: number) => void;
    disabled: boolean;
}

const RiskPickerTab: FC<RiskPickerTabProps> = ({ riskLevel, updateRiskLevel, disabled }) => {
    return (
        <div className="border border-sf-gray-100 rounded-lg w-full h-fit px-6 py-4 flex gap-2 items-center">
            <Dropdown
                disabled={disabled}
                variant={'trigger'}
                items={RISK_OPTIONS}
                selectedItems={riskLevel}
                onChange={(value) => updateRiskLevel(Array.isArray(value) ? value[0] : value)}
                size="small"
                className="!w-40"
            />
            <span className="font-sf text-13">or lower</span>
        </div>
    );
};

export default RiskPickerTab;
